/** 未单独配置下载地址的品牌继续使用历史中转页，避免改变现有行为。 */
export const DEFAULT_APP_DOWNLOAD_URL = 'https://h5.rocnovel.com/rocnovel/app?target={target}#/rocnovel/app'
